export default "__VITE_ASSET__YWm$lKPl__"